import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { EditorialStrip } from "@/components/landing/EditorialStrip";
import { PainPoints } from "@/components/landing/PainPoints";
import { Packages } from "@/components/landing/Packages";
import { Results } from "@/components/landing/Results";
import { About } from "@/components/landing/About";
import { Contacts } from "@/components/landing/Contacts";
import { Footer } from "@/components/landing/Footer";
import PrivacyPage from "@/pages/PrivacyPage";
import ApplySupportPage from "@/pages/ApplySupportPage";
import ApplyControlPage from "@/pages/ApplyControlPage";
import ApplyLaunchPage from "@/pages/ApplyLaunchPage";
import ScrollToTop from "@/components/ScrollToTop";

const Landing = () => {
    return (
        <div
            data-testid="landing-page"
            className="min-h-screen bg-[#F4F1EA] text-[#1B2A41] font-mont"
        >
            <Header />
            <main>
                <Hero />
                <EditorialStrip />
                <PainPoints />
                <Packages />
                <Results />
                <About />
                <Contacts />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-right"
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: "1px solid rgba(26,58,74,0.15)",
                        background: "#FFFFFF",
                        color: "#1B2A41",
                        fontFamily: "Montserrat, sans-serif",
                    },
                }}
            />
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/apply/support" element={<ApplySupportPage />} />
                    <Route path="/apply/control" element={<ApplyControlPage />} />
                    <Route path="/apply/launch" element={<ApplyLaunchPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
